"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfElectronicMedicalRecordSystemsUpdateDto = instanceOfElectronicMedicalRecordSystemsUpdateDto;
exports.ElectronicMedicalRecordSystemsUpdateDtoFromJSON = ElectronicMedicalRecordSystemsUpdateDtoFromJSON;
exports.ElectronicMedicalRecordSystemsUpdateDtoFromJSONTyped = ElectronicMedicalRecordSystemsUpdateDtoFromJSONTyped;
exports.ElectronicMedicalRecordSystemsUpdateDtoToJSON = ElectronicMedicalRecordSystemsUpdateDtoToJSON;
exports.ElectronicMedicalRecordSystemsUpdateDtoToJSONTyped = ElectronicMedicalRecordSystemsUpdateDtoToJSONTyped;
const ElectronicMedicalRecordSystemDto_1 = require("./ElectronicMedicalRecordSystemDto");
/**
 * Check if a given object implements the ElectronicMedicalRecordSystemsUpdateDto interface.
 */
function instanceOfElectronicMedicalRecordSystemsUpdateDto(value) {
    if (!('electronicMedicalRecordSystems' in value) || value['electronicMedicalRecordSystems'] === undefined)
        return false;
    return true;
}
function ElectronicMedicalRecordSystemsUpdateDtoFromJSON(json) {
    return ElectronicMedicalRecordSystemsUpdateDtoFromJSONTyped(json, false);
}
function ElectronicMedicalRecordSystemsUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'electronicMedicalRecordSystems': (json['electronicMedicalRecordSystems'].map(ElectronicMedicalRecordSystemDto_1.ElectronicMedicalRecordSystemDtoFromJSON)),
    };
}
function ElectronicMedicalRecordSystemsUpdateDtoToJSON(json) {
    return ElectronicMedicalRecordSystemsUpdateDtoToJSONTyped(json, false);
}
function ElectronicMedicalRecordSystemsUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'electronicMedicalRecordSystems': (value['electronicMedicalRecordSystems'].map(ElectronicMedicalRecordSystemDto_1.ElectronicMedicalRecordSystemDtoToJSON)),
    };
}
//# sourceMappingURL=ElectronicMedicalRecordSystemsUpdateDto.js.map